module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "splashscreen-logo.26d9f900.png";